export enum MyMahiStatusType {
    PENDING = "pending",
    COMPLETED = "completed",
    CANCELLED = "cancelled",
}